import { useState, useEffect, useCallback } from 'react'
import { kebabCase } from 'lodash'
import _data from '../../../common/utils/_data'
import Project from '../../../common/project'

/** Get area or subarea from slug e.g. "planning-permission" */
export function useAreaFromSlug(areaSlug?: string) {
  const [area, setArea] = useState<any>(null)

  const fetchArea = useCallback(() => {
    _data
      .get(`${Project.liveApi}law-categorisation/get-discover-law-data`)
      .then((data) => {
        const matchedArea = data
          .flatMap((x: any) => [x.area, ...x.subareas])
          .map((x: any) => ({ ...x, areaSlug: kebabCase(x.master_term) }))
          .find((x: any) => kebabCase(x.areaSlug) === areaSlug)

        setArea(matchedArea)
      })
      .catch((error) => console.error(error))
  }, [areaSlug])

  useEffect(fetchArea, [fetchArea, areaSlug])

  return area
}
